<template>
  <base-container class="filters">
    <div class="filters__label flexed-row">
      <span>FILTRER</span>
      <div class="filters__label-divider"></div>
    </div>
    <div class="filters__wrapper flexed-row">
      <div class="filters__multiselects flexed-row">
        <multiSelect
          :placeholder="marques.placeholder"
          :trackBy="marques.trackBy"
          :options="marques.options"
          @change="handleMarquesChanged"
          class="filters__multiselect"
        ></multiSelect>
        <multiSelect
          :placeholder="thematiques.placeholder"
          :trackBy="thematiques.trackBy"
          :options="thematiques.options"
          @change="handleThemesChanged"
          class="filters__multiselect"
        ></multiSelect>
        <multiSelect
          :placeholder="supportstypes.placeholder"
          :trackBy="supportstypes.trackBy"
          :options="supportstypes.options"
          @change="handleSupportsChanged"
          class="filters__multiselect"
        ></multiSelect>
      </div>
    </div>
  </base-container>
</template>

<script>
import MultiSelect from "@/components/MultiSelect.vue"
import { mapState } from "vuex"
export default {
  computed: {
    ...mapState({
      supportstypes: state => state.supportstypes.data,
      marques: state => state.marques.data,
      thematiques: state => state.thematiques.data
    })
  },
  components: {
    MultiSelect
  },
  methods: {
    handleMarquesChanged(marques) {
      this.$emit("marquesChange", marques)
    },
    handleThemesChanged(themes) {
      this.$emit("themesChange", themes)
    },
    handleSupportsChanged(supports) {
      this.$emit("supportsChange", supports)
    }
  },
  mounted() {
    this.$store.dispatch("getMarques")
    this.$store.dispatch("getThematiques")
    this.$store.dispatch("getSupportsTypes")
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.flexed-row {
  display: flex;
  flex-flow: row nowrap;
}

.filters {
  $self: &;
  &__label {
    width: 100%;
    align-items: center;
    color: $color-primary;
    color: var(--color-primary, $color-primary);
    font-size: 0.675em;
    font-weight: 600;
    margin-bottom: 14px;
    span {
      margin-right: 16px;
    }
  }

  &__label-divider {
    flex-grow: 1;
    border-bottom: 1px solid $color-primary;
    border-bottom: 1px solid var(--color-primary, $color-primary);
  }

  &__wrapper {
    align-items: center;
  }

  &__multiselects {
    width: 100%;
    justify-content: space-between;

    #{$self}__multiselect {
      align-self: flex-start;
    }
  }

  &__checkboxes {
    margin-left: 16px;
    align-self: flex-start;
    margin-top: 14px;
    label:first-child {
      margin-right: 12px;
    }
  }
}
</style>
